import { render } from "./ProductsIndexButtonAdd.vue?vue&type=template&id=3cd22288"
import script from "./ProductsIndexButtonAdd.vue?vue&type=script&lang=js"
export * from "./ProductsIndexButtonAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__